import { Link } from "react-router-dom";
import { CATEGORY_LABELS } from "../lib/constants";

export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="bg-muted border border-hair p-6 sticky top-24">
            <div className="flex items-center gap-2 border-b-2 border-ink pb-3 mb-4">
                <span className="w-2 h-2 bg-accent" />
                <h4 className="font-mono text-xs font-bold uppercase tracking-[0.15em]">Trending Now</h4>
            </div>
            <ol className="space-y-5">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-3"
                        >
                            <span className="font-serif text-2xl font-bold text-accent leading-none w-7 shrink-0">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div>
                                <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-sans text-sm font-semibold leading-snug group-hover:text-accent transition-colors duration-150">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-muted-foreground">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
